<template>
    <div class="box">
        <div class="box-content">
            <div class="flex justify-end">
                <div class="flex pb-5">
                    <!--<div class="pr-3">
                        <select class="form-control" v-model="user_filter">
                            <option value="" v-if="user_filter === ''">Customer ... </option>
                            <option value="" v-else> Clear Filter </option>
                            <option v-for="status in enquiry_statuses" :value="status.id">
                                {{ status.label }}
                            </option>
                        </select>
                    </div>-->
                </div>
            </div>
            <table class="table _lined">
                <thead>
                <tr>
                    <th>Date Received</th>
                    <th>Project Name</th>
                    <th>From</th>
                   <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(case_study, index) in case_studies">
                    <td>
                        {{ case_study.friendly_created_at }}
                    </td>
                    <td>
                        {{ case_study.project_name }}
                    </td>
                    <td>
                        {{ case_study.company_name }}
                    </td>
                    <td class="align-right">
                        <a :href='"/commercial/case-studies/"+case_study.id' class="txt-primary">
                            <i class="fa fa-eye"></i>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <template>
                <div class="pagination-bar wrapper mb-3 mt-3">
                    <div class="row">
                        <div class="col">
                            <a @click.prevent="prevPage()" v-if="current_page > 1" class="btn-default _sm"><i
                                class="fa fa-caret-left"></i></a>
                            <a class="btn-default _sm">{{ current_page }} / {{ total_pages }}</a>
                            <a @click.prevent="nextPage()" v-if="current_page < total_pages"
                               class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                        </div>
                        <div class="col align-right">
                            <div class="mt-1 mb-1">
                                {{ total_count }} results found
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        this.loadCaseStudies();
    },
    data() {
        return {
            case_studies: [],
            current_page: 1,
            total_count: 0,
            total_pages: 0,
            limit: 20,
        }
    },
    methods: {
        loadCaseStudies() {
            axios.post('/commercial/case-studies/loadCaseStudies', {
                page_number: this.current_page,
                limit: this.limit,
            }).then((response) => {
                this.case_studies = response.data.data;
                this.total_count = response.data.total;
                this.total_pages = response.data.last_page;
            });
        },
        prevPage() {
            this.current_page = this.current_page - 1;
            this.loadCaseStudies();
        },
        nextPage() {
            this.current_page = this.current_page + 1;
            this.loadCaseStudies();
        }
    },
    watch: {
        /*user_filter() {
            this.current_page = 1;
            this.loadCaseStudies();
        },*/
    },
};
</script>
